var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { styled } from 'styled-components';
import { Table, } from '../../../../../Common/components/Table';
import { StudentsTableColumnWidth, isStudentCell, updateStudentInList, } from './tableConfig';
import { ActionsCell } from './ActionsCell';
import { StudentNameCell } from './StudentNameCell';
import { useStudentsTableData } from './useStudentsTableData';
import { StatusHeaderCell } from '../../../../components/StatusHeaderCell';
import { useLazyCancelStudentAssignment } from '../../../../hooks/useLazyCancelStudentAssignment';
import { CancelModal } from '../../../../components/CancelModal';
import { useAppGoogleAnalytics } from '../../../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from '../../../../constants/analytics';
import { CardsStatus } from './CardsStatus';
import { useTableRowActions } from './useTableRowActions';
import { InviteColleaguesAssessmentModal } from '../../../AssignmentsList/components/InviteColleaguesAssessmentModal';
import { UpgradePremiumAssessmentModal } from '../../../AssignmentsList/components/UpgradePremiumAssessmentModal';
import { buildURI, useToggle } from '@hn-front/utils';
import { usePostEvent } from '../../../../../Common/hooks/usePostEvent';
import { ASSIGNMENTS_API, ASSIGNMENTS_ROUTES, } from '../../../../constants/routes';
import { useNavigate } from 'react-router';
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-6z3cpb" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: contents;\n\n  & > table {\n    & > thead th {\n      padding-top: 30px;\n      padding-bottom: 12px;\n    }\n\n    & > tbody {\n      tr:first-child td {\n        padding-top: 15px;\n      }\n\n      > tr.hoverable:hover {\n        cursor: pointer;\n        background-color: ", ";\n      }\n\n      td {\n        font-size: 16px;\n        line-height: 24px;\n        padding: 11px 0;\n        vertical-align: middle;\n      }\n\n      [data-role='sub-row'] td {\n        padding-top: 0;\n      }\n    }\n  }\n"], ["\n  display: contents;\n\n  & > table {\n    & > thead th {\n      padding-top: 30px;\n      padding-bottom: 12px;\n    }\n\n    & > tbody {\n      tr:first-child td {\n        padding-top: 15px;\n      }\n\n      > tr.hoverable:hover {\n        cursor: pointer;\n        background-color: ", ";\n      }\n\n      td {\n        font-size: 16px;\n        line-height: 24px;\n        padding: 11px 0;\n        vertical-align: middle;\n      }\n\n      [data-role='sub-row'] td {\n        padding-top: 0;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue99;
});
var StatusWrapper = styled.div.withConfig({ displayName: "StatusWrapper", componentId: "sc-o23dm2" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var StatusCell = function (_a) {
    var _b;
    var statusItems = _a.statusItems;
    return ((_b = (_jsx(StatusWrapper, { children: _jsx(CardsStatus, { items: statusItems }, void 0) }, void 0))) !== null && _b !== void 0 ? _b : null);
};
var StudentsTable = function (_a) {
    var groupId = _a.groupId, assignment = _a.assignment, props = __rest(_a, ["groupId", "assignment"]);
    var _b = React.useState(), assignmentRestriction = _b[0], setAssignmentRestriction = _b[1];
    var revalidateGroupInfo = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetch(buildURI(ASSIGNMENTS_API.groupInfo, { pathParams: { groupId: groupId } }), { headers: { 'Content-Type': 'application/json' } })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_c.sent()).data;
                    setAssignmentRestriction({
                        allowAssignments: (_a = data.assignments) === null || _a === void 0 ? void 0 : _a.allowAssignments,
                        wayToObtainAccess: (_b = data.assignments) === null || _b === void 0 ? void 0 : _b.wayToObtainAccess,
                    });
                    return [2 /*return*/, data];
            }
        });
    }); }, []);
    React.useEffect(function () {
        revalidateGroupInfo();
    }, []);
    var assignmentId = assignment.id, students = assignment.students, cards = assignment.cards, allowReassign = assignment.allowReassign;
    var _c = React.useState(), studentToCancel = _c[0], setStudentToCancel = _c[1];
    var _d = useLazyCancelStudentAssignment(groupId), fetchCancelStudentAssignment = _d[0], cancelLoading = _d[1].isLoading;
    var _e = useStudentsTableData({
        students: students,
    }), tableData = _e.tableData, updateStudents = _e.updateStudents, currentStudents = _e.currentStudents;
    var ga = useAppGoogleAnalytics();
    var handleStudentRowClick = React.useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage,
            action: ASSIGNMENTS_EVENTS.assign_report_page_student_click,
        });
    }, [ga]);
    var navigate = useNavigate();
    var handleStudentReassignClick = React.useCallback(function (assignmentId, studentId) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, revalidateGroupInfo()];
                case 1:
                    data = _c.sent();
                    if (!((_a = data === null || data === void 0 ? void 0 : data.assignments) === null || _a === void 0 ? void 0 : _a.allowAssignments)) {
                        if (((_b = data === null || data === void 0 ? void 0 : data.assignments) === null || _b === void 0 ? void 0 : _b.wayToObtainAccess) === 'premium')
                            toggleUpgradePremiumModal();
                        else
                            toggleInviteColleaguesModal();
                        return [2 /*return*/];
                    }
                    ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
                        category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage,
                        action: ASSIGNMENTS_EVENTS.assign_report_page_reassign_click,
                    });
                    navigate(buildURI(ASSIGNMENTS_ROUTES.createAssignmentFromAnotherForStudent, {
                        pathParams: { assignmentId: assignmentId, studentId: studentId },
                    }));
                    return [2 /*return*/];
            }
        });
    }); }, [ga, navigate]);
    var handleStudentCancelClick = React.useCallback(function (student) {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage,
            action: ASSIGNMENTS_EVENTS.assign_report_page_cancel_click,
        });
        setStudentToCancel(student);
    }, [ga]);
    var onCancelAssignment = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var reponse, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!studentToCancel)
                        return [2 /*return*/];
                    return [4 /*yield*/, fetchCancelStudentAssignment(assignmentId, studentToCancel.id)];
                case 1:
                    reponse = (_a.sent());
                    return [4 /*yield*/, reponse.json()];
                case 2:
                    data = (_a.sent()).data;
                    setStudentToCancel(undefined);
                    updateStudents(updateStudentInList({
                        assignments: currentStudents,
                        updatedStudentId: data.id,
                        params: {
                            status: "canceled_by_teacher" /* CanceledByTeacher */,
                            cards: data.cards,
                            statusItems: data.cards.map(function (card) {
                                return ({
                                    status: card.status,
                                    intervention: card.interventionMark,
                                });
                            }),
                        },
                    }));
                    return [2 /*return*/];
            }
        });
    }); }, [
        assignmentId,
        currentStudents,
        fetchCancelStudentAssignment,
        studentToCancel,
        updateStudents,
    ]);
    var columns = React.useMemo(function () {
        return [
            {
                id: 'Student',
                Header: 'Student',
                Cell: StudentNameCell,
                disableSortBy: true,
                style: {
                    minWidth: StudentsTableColumnWidth.NAME,
                    maxWidth: StudentsTableColumnWidth.NAME,
                },
            },
            {
                id: 'Status',
                Header: function () { return _jsx(StatusHeaderCell, {}, void 0); },
                Cell: function (_a) {
                    var original = _a.row.original;
                    return isStudentCell(original) ? (_jsx(StatusCell, { statusItems: original.statusItems }, void 0)) : null;
                },
                disableSortBy: true,
                style: {
                    minWidth: StudentsTableColumnWidth.STATUS,
                    maxWidth: StudentsTableColumnWidth.STATUS,
                },
            },
            {
                id: 'Time',
                Header: 'Time spent',
                Cell: function (_a) {
                    var original = _a.row.original;
                    if (!isStudentCell(original))
                        return null;
                    return original.timeSpent ? original.timeSpent + " min" : '–';
                },
                disableSortBy: true,
                style: {
                    minWidth: StudentsTableColumnWidth.TIME,
                    maxWidth: StudentsTableColumnWidth.TIME,
                    textAlign: 'right',
                },
            },
            {
                id: 'Accuracy',
                Header: 'Accuracy',
                Cell: function (_a) {
                    var original = _a.row.original;
                    if (!isStudentCell(original))
                        return null;
                    return original.total ? original.accuracy + " %" : '–';
                },
                disableSortBy: true,
                style: {
                    minWidth: StudentsTableColumnWidth.ACCURACY,
                    maxWidth: StudentsTableColumnWidth.ACCURACY,
                    textAlign: 'right',
                },
            },
            {
                id: 'Actions',
                Cell: function (cell) { return (_jsx(ActionsCell, __assign({}, cell, { assignmentId: assignmentId, allowReassign: allowReassign, onCancelClick: handleStudentCancelClick, onReassignClick: handleStudentReassignClick, allowAssignments: assignmentRestriction === null || assignmentRestriction === void 0 ? void 0 : assignmentRestriction.allowAssignments }), void 0)); },
                disableSortBy: true,
                style: {
                    minWidth: StudentsTableColumnWidth.ACTIONS,
                    maxWidth: StudentsTableColumnWidth.ACTIONS,
                    marginLeft: 'auto',
                },
            },
        ];
    }, [assignmentId, handleStudentCancelClick, handleStudentReassignClick]);
    var getExpandableRowProps = React.useCallback(function (row) {
        var rowProps = row.getToggleRowExpandedProps({ title: undefined });
        var isDisabled = !isStudentCell(row.original);
        var onExpandClick = function () {
            var _a;
            if (isDisabled)
                return;
            handleStudentRowClick();
            (_a = rowProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rowProps);
        };
        if (isDisabled)
            return {};
        return { className: 'hoverable', onClick: onExpandClick };
    }, [handleStudentRowClick]);
    var _f = useTableRowActions({ cards: cards }), renderSubRow = _f.renderSubRow, updateRow = _f.updateRow;
    var _g = useToggle(), isInviteColleaguesModal = _g.isToggled, toggleInviteColleaguesModal = _g.toggle;
    var handleOnPremium = React.useCallback(function () {
        document.location.href = '/pricing';
    }, []);
    var postEvent = usePostEvent()[0];
    var handleOnInvite = React.useCallback(function () {
        postEvent('invite_colleagues_no_addons', { type: 'assignments' }).then(function () {
            document.location.href = '/teachers/boarding';
        });
    }, []);
    var _h = useToggle(), isUpgradePremiumModal = _h.isToggled, toggleUpgradePremiumModal = _h.toggle;
    return (_jsxs(ScWrapper, { children: [_jsx(Table, __assign({ columns: columns, data: tableData, isFlexLayout: false, stickyHeader: true, testId: 'assignment-students-table', getAdditionalRowProps: getExpandableRowProps, renderSubRow: renderSubRow, updateRow: updateRow }, props), void 0), _jsx(CancelModal, { "data-testid": 'assignment-students-table-cancel-modal', open: Boolean(studentToCancel), title: "Cancel assignment for " + (studentToCancel === null || studentToCancel === void 0 ? void 0 : studentToCancel.name) + "?", onCancelClick: onCancelAssignment, onCloseClick: function () { return setStudentToCancel(undefined); }, loading: cancelLoading }, void 0), _jsx(InviteColleaguesAssessmentModal, { open: isInviteColleaguesModal, onClose: toggleInviteColleaguesModal, onInvite: handleOnInvite, onPremium: handleOnPremium }, void 0), _jsx(UpgradePremiumAssessmentModal, { open: isUpgradePremiumModal, onClose: toggleUpgradePremiumModal, onPremium: handleOnPremium }, void 0)] }, void 0));
};
export { StudentsTable };
var templateObject_1, templateObject_2;
